import { toThousands } from '@patsnap/synapse_common_utils'
import { IPatentAssignee } from '@pharmsnap/shared/types'

export function getAssigneeName(assignee: IPatentAssignee, isCN = false, withCount = false) {
  const assigneeName = isCN ? assignee.display_name_cn || assignee.display_name_en : assignee.display_name_en || assignee.display_name_cn
  return withCount ? `${assigneeName}(${toThousands(assignee.count)})` : assigneeName
}
